export default {
  baseApiUrl: "https://kd-core-api.azurewebsites.net",
  kdcoreUrl: "https://www.logikin.jp/",
  name: "",
  deployFolder: "",
  baseUrl: "",
  applicationInsightsKey: "8aef77aa-6902-4b51-bef8-20d31d9e508c",
  gtmId: "",
};
